export const tr = {
    'adgroup-demography-multipliers': 'Yaş ve cinsiyete göre grup için teklif düzenlemeleri',
    'adgroup-mobile-multiplier': 'Mobile göre grup için teklif düzenlemeleri',
    'adgroup-performance-tgo-multiplier': 'Akıllı reklamlara göre grup için teklif düzenlemeleri',
    'adgroup-regions': 'Grubun görüntüleme bölgesi',
    'adgroup-retargeting-multipliers': 'Hedef kitleye göre grup için teklif düzenlemeleri',
    'adgroup-video-multiplier': 'Video eklentilere göre grup için teklif düzenlemeleri',
    'banner-status': 'Reklam durumu',
    'banners-archived': 'Reklam arşive kaldırıldı',
    'banners-hide': 'Reklam durduruldu',
    'banners-show': 'Reklam etkinleştirildi',
    'banners-unarchived': 'Reklam arşivden çıkarıldı',
    'campaign-archived': 'Kampanya arşive taşındı',
    'campaign-broad-match': 'İlgili ek sözcük grupları',
    'campaign-creation': 'Kampanya oluşturuldu',
    'campaign-demography-multipliers': 'Yaş ve cinsiyete göre teklif düzenlemeleri',
    'campaign-disabled-domains': 'Engelli siteler',
    'campaign-disabled-ips': 'Engelli IP adresleri',
    'campaign-disabled-ssp': 'Yasaklı harici siteler',
    'campaign-extended-geotargeting': 'Genişletilmiş coğrafi hedefleme',
    'campaign-finish-time': 'Kampanyanın bitiş tarihi',
    'campaign-hide': 'Kampanya durduruldu',
    'campaign-minus-words': 'Kampanya için negatif anahtar sözcük grupları',
    'campaign-mobile-multiplier': 'Mobil için teklif düzenlemeleri',
    'campaign-network': 'Ağlarda ayarlar',
    'campaign-performance-tgo-multiplier': 'Akıllı reklamlar için teklif düzenlemeleri',
    'campaign-regions': 'Gösterim bölgesi',
    'campaign-restrict-frequency': 'Gösterim sıklığını sınırla',
    'campaign-retargeting-multipliers': 'Hedef kitle için teklif düzenlemeleri',
    'campaign-show': 'Kampanya etkinleştirildi',
    'campaign-start-time': 'Kampanyanın başlangıç tarihi',
    'campaign-status': 'Kampanya durumu',
    'campaign-strategy': 'Strateji',
    'campaign-time-target': 'Zaman hedefleme',
    'campaign-unarchived': 'Kampanya arşivden çıkarıldı',
    'campaign-video-multiplier': 'Video eklentiler için teklif düzenlemeleri',
    off: 'Kapalı',
    on: 'Açık',
    yandex: 'Yandex'
};
